"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUM = void 0;
exports.SUM = {
    information: {
        definition: '',
        description: '',
        requiredInputs: { min: 0 },
    },
    evaluate: (inputs) => {
        let sum = 0;
        // eslint-disable-next-line no-restricted-syntax
        for (const input of inputs) {
            // Array inputs
            if (Array.isArray(input)) {
                let arraySum = 0;
                // eslint-disable-next-line no-restricted-syntax
                for (let rowIdx = 0; rowIdx < input.length; rowIdx += 1) {
                    const arrayElement = input[rowIdx];
                    if (typeof arrayElement !== 'number') {
                        return { error: 'Array elements for SUM must be numbers' };
                    }
                    arraySum += arrayElement;
                }
                sum += arraySum;
            }
            else if (typeof input === 'number') {
                // Number inputs
                sum += input;
            }
            else {
                return {
                    error: 'Input values for SUM must be numbers or arrays of numbers',
                };
            }
        }
        return { error: null, result: sum };
    },
};
//# sourceMappingURL=sum.js.map